import React from 'react';

const AdminContent = () => (
  <div className="admin-content">
    <h3>Content Management</h3>
    <p>Upload, edit and publish content — UI to be implemented.</p>
  </div>
);

export default AdminContent;
